import { InputDecimal } from '@/components/_common';
import CheckIcon from '@/components/_common/CheckIcon';
import { InputDecimalProps } from '@/components/_common/InputDecimal';
import { quantityFormatter } from '@/utils/number';
import { InputRef } from 'antd';
import { useEffect, useRef } from 'react';

import './style.less';

interface Props extends Omit<InputDecimalProps, 'defaultValue'> {
  loading?: boolean;
  onConfirmValue?: (value: number) => void;
  onClose?: VoidFunction;
  defaultValue?: number;
}

export default function InputDecimalCell(props: Props) {
  const inputRef = useRef<InputRef>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        props.onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    inputRef.current?.select();
  }, []);

  const handleConfirmValue = () => {
    const rawValue = inputRef.current?.input?.value || '0';
    const formattedValue = rawValue.replace(/\./g, '').replace(',', '.');
    const value = Number(formattedValue);

    if (value === props.defaultValue) return props.onClose?.();

    return props.onConfirmValue?.(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (props.loading) return;

    if (event.key === 'Enter') return handleConfirmValue();

    if (event.key === 'Escape') return props.onClose?.();
  };

  return (
    <div ref={containerRef}>
      <InputDecimal
        {...props}
        defaultValue={quantityFormatter(props.defaultValue || 0)}
        addonAfter={
          <div className="container-check" onClick={handleConfirmValue}>
            <CheckIcon popover="Salvar" loading={props.loading} />
          </div>
        }
        ref={inputRef}
        disabled={props.loading}
        onKeyDown={handleKeyDown}
        className="input-decimal-cell"
      />
    </div>
  );
}
